import { asPage } from 'src/components/hoc/asPage'
import { Recommend } from 'src/compositions/Recommend'

export default asPage(Recommend, { pageTitle: '今日のAIピック' })
